import React from 'react'

function ComingSoon() {
  return (
    <div className='lg:min-h-[90vh] min-h-[50vh] flex-center'>
      <img src="/images/vectors/coming-soon.png" alt="Coming Soon" />
    </div>
  )
}

export default ComingSoon